const Constants = {
    maxTextLength: 50, // max text length for TextField
    minTextLength: 3 // min text length for TextField
}
export default Constants